<script lang="ts">
	import classNames from 'classnames';
	import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';
	import type { RegisterInterestType } from '#lib/websites/register-interest/constants/mixpanel-events.js';
	import { trackRegisterInterestClicked } from '#lib/websites/register-interest/utils/trackRegisterInterest/trackRegisterInterest.js';
	import { LinkButton } from '$global/components/LinkButton';
	import { Txt } from '$global/components/Txt';
	import type { ContentKey } from '$global/utils/contentKey';

	interface Props {
		code: string;
		dataCy: string;
		contentKey?: ContentKey;
	}

	let { code, dataCy, contentKey }: Props = $props();

	// Tracked here rather than at each call site (HB-974): the same click on the
	// editions PDP, series page, primary PDP and drop pages then emits one
	// consistently-shaped event, and a new surface gets the tracking for free.
	const handleClick = (interestType: RegisterInterestType) => () => {
		trackRegisterInterestClicked({ interestType, contentKey });
	};
</script>

<hr class={'mt-8 lg:hidden'} />
<Txt variant="h6" class={classNames('mt-6 mb-2 lg:mt-12')}
	>Register Interest</Txt
>
<Txt variant="body1" class="mb-6">
	This release has ended but it may be possible to buy/sell from other
	collectors on the secondary market.
</Txt>
<div class="xs:flex grid grid-cols-2 gap-4">
	<LinkButton
		{dataCy}
		size="md"
		class="xs:w-[9rem]"
		fullWidth
		onclick={handleClick('buying')}
		href={`${GlobalRoutes.RegisterInterest}?i=buying&c=${code}`}
	>
		buy
	</LinkButton>
	<LinkButton
		{dataCy}
		size="md"
		class="xs:w-[9rem]"
		fullWidth
		onclick={handleClick('selling')}
		href={`${GlobalRoutes.RegisterInterest}?i=selling&c=${code}`}
	>
		sell
	</LinkButton>
</div>

<hr class="mt-8 lg:hidden" />
